import { Card, Grid } from "@mui/material";
import { useEffect } from "react";
import { FormProvider } from "src/components/hook-form";
import useResponsive from "src/hooks/useResponsive";

import Context, { ContextType } from "./context";
import DemoPanel from "./DemoPanel/DemoPanel";
import { useCustomizeForm } from "./hooks/useCustomizeForm";
import RestoreThemeDialog from "./RestoreThemeDialog/RestoreThemeDialog";
import useCustomizeActionsStore from "./store";
import StylingPanel from "./StylingPanel";

export default function CustomizeCard() {
	const [state, actions] = useCustomizeActionsStore();
	const { methods, reset, onSubmit } = useCustomizeForm();
	const isDownXl = useResponsive("down", "xl");
	const isDownLg = useResponsive("down", "lg");

	const context: ContextType = {
		values: methods.watch(),
		state,
		actions: { ...actions, setValue: methods.setValue, reset }
	};

	useEffect(() => {
		if (isDownLg) {
			actions.onChangeViewType(true);
		}
	}, [isDownLg]);

	return (
		<Card sx={{ width: " 90%", margin: "0 auto", mb: 3 }}>
			<Context.Provider value={context}>
				<Grid container sx={{ height: 800 }}>
					<Grid item xl={3} lg={state.isMobile ? 3 : 0} md={state.isMobile ? 4 : 0}>
						<FormProvider methods={methods} onSubmit={onSubmit}>
							{(state.isMobile || !isDownXl) && <StylingPanel />}
						</FormProvider>
					</Grid>
					<Grid
						item
						xl={9}
						lg={state.isMobile ? 9 : 12}
						md={state.isMobile ? 8 : 12}
						sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
					>
						<DemoPanel />
					</Grid>
				</Grid>
				<RestoreThemeDialog />
			</Context.Provider>
		</Card>
	);
}
